import { setAuth, setProfile } from "../reducers/authReducer";
import { setConfig } from "../reducers/configReducer";
import setAuthToken from "../utils/setAuthToken";
import { siteInfo } from "../utils/SiteInfo";
import { getData } from "../api/api";

export const saveConfig = () => (dispatch) => {
  getData("config", (res) => {
    if (res) {
      localStorage.setItem("config", JSON.stringify(res));
      dispatch(setConfig(res));
    }
  });
};
export const logoutAdmin = (afterFunction) => (dispatch) => {
  localStorage.removeItem(siteInfo.sitekey);
  localStorage.removeItem("config");
  setAuthToken(null);
  dispatch(setAuth(false));
  dispatch(setProfile(null));
  dispatch(setConfig(null));
  afterFunction(true);
};

export const setAdmin = (isAuthenticated) => (dispatch) => {
  dispatch(setAuth(isAuthenticated));
};
